import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    CategoryScale,
} from "chart.js";
import { ThreeDots } from "react-loader-spinner";
import "./AnalyticsCallDurationGraph.css";

ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend, CategoryScale);

const buildBins = (max) => {
    const bins = [];
    for (let i = 0; i < 60; i += 10) bins.push(i);
    for (let i = 60; i < 180; i += 30) bins.push(i);
    for (let i = 180; i < max + 60; i += 60) bins.push(i);
    return bins;
};

const AnalyticsCallDurationGraph = ({ conversations, loading }) => {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        const durations = conversations
            .filter((conv) => conv && typeof conv.duration === "number" && conv.duration > 0)
            .map((conv) => conv.duration);

        if (durations.length === 0) {
            setChartData(null);
            return;
        }

        const maxDuration = Math.max(...durations);
        const bins = buildBins(maxDuration);
        const counts = new Array(bins.length - 1).fill(0);

        durations.forEach((d) => {
            for (let i = 0; i < bins.length - 1; i++) {
                if (d >= bins[i] && d < bins[i + 1]) {
                    counts[i]++;
                    break;
                }
            }
        });

        const labels = bins.slice(0, -1).map((val, i) => `${val}-${bins[i + 1]}s`);

        setChartData({
            labels,
            datasets: [
                {
                    label: "Number of calls",
                    data: counts,
                    borderColor: "#3b82f6",
                    backgroundColor: "rgba(59, 130, 246, 0.1)",
                    fill: true,
                    tension: 0.4,
                    cubicInterpolationMode: "monotone",
                    pointRadius: 0,
                },
            ],
        });
    }, [conversations]);

    if (!chartData) return null;

    return (
        <div id="analytics-call-duration-graph">
            <h2 className="title-call-duration">Distribution of call durations</h2>
            {loading ? (
                <div className="loader-container">
                    <ThreeDots height="100" width="100" color="var(--main)" ariaLabel="loading" />
                </div>
            ) : (
                <Line
                    data={chartData}
                    options={{
                        responsive: true,
                        interaction: {
                            intersect: false,
                        },
                        scales: {
                            x: {
                                title: {
                                    display: true,
                                    text: "Call duration",
                                },
                            },
                            y: {
                                title: {
                                    display: true,
                                    text: "Number of calls",
                                },
                                beginAtZero: true,
                                ticks: {
                                    stepSize: 1,
                                },
                                suggestedMax: Math.max(...chartData.datasets[0].data) + 2,
                            },
                        },
                    }}
                />
            )}
        </div>
    );
};

export default AnalyticsCallDurationGraph;
